export function useNoticeBoardPost() {
  const getAllPosts = async () => {
    const res = await $fetch(`/api/v1/notice-board-posts`, {
      method: 'GET',
    })
    return res
  }

  const createPost = async (body: any) => {
    const res = await $fetch(`/api/v1/notice-board-posts`, {
      method: 'POST',
      body: body,
    })
    return res
  }

  const deletePost = async (postId: string) => {
    const res = await $fetch(`/api/v1/notice-board-posts/${postId}`, {
      method: 'DELETE',
    })
    return res
  }
  return {
    getAllPosts,
    createPost,
    deletePost,
  }
}
